<ng-container>
  <label [for]="inputName" class="animated fadeInUp"
    [class.floating]="getFloating(input)"
    [class.hidden]="getHidden(input)">
    {{labelText}}
  </label>
  @for (error of errors; track error) {
    @if ((((input.touched || focused) && showDelayed && !validationIconHidden) || (forceValidate && !(input.touched || focused))) &&
      (input.invalid && input.errors[error.name]) ) {
      <div class="error">
        {{error.text}}
      </div>
    }
  }

  <div class="re-relative">
    <textarea #input="ngModel"
      [(ngModel)]="inputValue"
      [name]="inputName"
      [id]="inputName"
      (focus)="onFocus()"
      [required]="required"
      [bdoDefaultValidator]="errors"
      [placeholder]="placeholder"
      [rows]="rows"
      [maxlength]="maxLength"
      (blur)="onBlur()"
    (ngModelChange)="onChange($event)"></textarea>
    @if ((maxLength)) {
      <div class="re-text-xs re-text-right">{{inputValue?.length ? inputValue?.length : 0}} / {{maxLength}}</div>
    }
    @if (((forceValidate && !(input.touched || focused)) || showDelayed) && !validationIconHidden) {
      <div class="validation-icon">
        <bdo-svg [name]="input.valid? 'icon-success' : 'icon-alert'" [styling]="input.valid? 'bdo-svg--success' : 'bdo-svg--error'"></bdo-svg>
      </div>
    }
  </div>
</ng-container>
